import { IHref } from './server';

const WHITELISTED = 1;
const BLACKLISTED = -1;
const UNDEFINED = 0;

export interface WhitelistType {
  [key: string]: boolean;
}

export default (whitelistedpaths: WhitelistType, href: IHref): boolean => {
  const res = Object.keys(whitelistedpaths).map(item =>
    new RegExp(item).exec(href.pathname) !== null
      ? whitelistedpaths[item]
        ? WHITELISTED
        : BLACKLISTED
      : UNDEFINED
  );
  return !(res.some(item => item === BLACKLISTED) || res.every(item => item === UNDEFINED));
};
